'use strict';
type SearchUnitService = Search.SearchUnitService;
type HolidayDeals = TR.HolidayDeals;

angular
    .module('searchUnit')
    .directive('dealsSearchUnit', dealsSearchUnit);

function dealsSearchUnit($location: ng.ILocationService,
                         holidayDeals: HolidayDeals,
                         searchUnitService: SearchUnitService,
                         sharedSearchUnitService,
                         broker: Core.Broker,
                         resourceService: Core.ResourceService,
                         dateUtil,
                         scrollTo,
                         analytics) {

    sharedSearchUnitService.addDelayedLinker(_delayedLinker, 'dealsSearchUnit');

    return {
        restrict: 'E',
        replace: true,
        scope: {
            areaOverride: '@',
            refresh: '=',
            noButton: '=',
            hideButton: '=',
            tracking: '=',
            pickMonths: '=',
            ldp: '=',
            writeToUrl: '='
        },
        templateUrl: 'partials/searchunit/deals',
        controller: 'SharedSearchUnit',
        link: function (scope, el, attr, controller) {
            broker.subscribe('dealsSearchUnit', 'autocompleterReady', function (e) {
                if (!$(e.data).isOnScreen()) {
                    let container = ($('.horizontal-search-wrapper').length !== 0)
                        ? '.horizontal-search-wrapper'
                        : '.search-panel';
                    scrollTo(container);
                }
            });

            scope.$on('$destroy', () => {
                broker.unsubscribe('dealsSearchUnit');
            });

            return sharedSearchUnitService.initializeArea(
                scope,
                el,
                attr,
                controller,
                'dealsSearchUnit'
            );
        }
    };

    function _delayedLinker(scope) {

        var currentArea = sharedSearchUnitService.getAreaInfo(scope.areaOverride);
        scope.area = currentArea.name;

        scope.durations = holidayDeals.DURATIONS.map(d => ({
            name: `${d} ${resourceService.get('NIGHTS')}`,
            value: d
        }));

        scope.airportDeselect = () => searchUnitService.clearDepartureAirports();

        scope.search = () => {
            const params = {
                airportsCodes: scope.airports,
                startDate: searchUnitService.startDate(currentArea.mode),
                duration: scope.duration,
                occupancy: scope.occupancy
            };

            analytics.track('mixpanel', 'Search', {
                Nights: params.duration,
                DepartureAirports: params.airportsCodes,
                TypeTitle: 'Holiday Deals',
                FromDate: { Date: params.startDate },
                Rooms: params.occupancy
            });

            if (!_validateParameters(params)) { return; }

            scope.refresh
                ? _refreshSearch(holidayDeals.serialiseParameters(params, false))
                : _startSearch(holidayDeals.serialiseParameters(params, false));
        };

        _restoreSearchCriteria(false);
        scope.$watch(() => _.size($location.search()), value => {
            if (value === 0) {
                _restoreSearchCriteria(true);
            }
        });

        function _restoreSearchCriteria(noWatch) {
            holidayDeals.getFullParameters(!!scope.writeToUrl).then(params => {
                scope.airports = params.depAir.map(a => ({ Code: a }));
                searchUnitService.setMultipleDepartureAirports(scope.airports);
                scope.startDate = searchUnitService.startDate(currentArea.mode, params.startDate);
                scope.duration = params.duration;
                scope.occupancy = params.occupancy;

                if (scope.refresh && !noWatch) {
                    scope.$watch(() => searchUnitService.startDate(currentArea.mode), (n, o) => {
                        _autoStartSearch(n, o);
                        if (scope.tracking && !angular.equals(n, o)) {
                            let date = dateUtil.parseDate(n);
                            let month = date.getMonth() + 1;
                            let year = date.getFullYear();
                            _trackChange('startDate', `month-${month}-${year}`);
                        }
                    }, true);

                    scope.$watch('occupancy', (n, o) => {
                        _autoStartSearch(n, o);
                        if (scope.tracking && !angular.equals(n, o)) {
                            n = n[0] || n;
                            const value:any = {
                                Adults: n.Adults,
                                Children: (n.ChildAges || []).length
                            };
                            _trackChange('Occupancy', value);
                        }
                    }, true);

                    scope.$watch('duration', (n, o) => {
                        _autoStartSearch(n, o);
                        if (scope.tracking && !angular.equals(n, o)) {
                            _trackChange('Duration', n);
                        }
                    });

                    scope.$watch('airports', (n, o) => {
                        if (_.size(n) === 0) { return; }
                        searchUnitService.setMultipleDepartureAirports(n);
                        if (scope.tracking && !angular.equals(n, o)) {
                            _trackChange('Airports');
                        }
                        return _autoStartSearch(n, o);
                    }, true);
                }
            });
        }

        function _autoStartSearch(newValue, oldValue) {
            if (newValue && scope.refresh && !angular.equals(newValue, oldValue)) {
                scope.search();
            }
        }

        function _trackChange(type, value?) {
            return value
                ? analytics.track('mixpanel', `HolidayDealsInsp${type}`, { value })
                : analytics.track('mixpanel', `HolidayDealsInsp${type}`);
        }

        function _refreshSearch(params) {
            for (let param in params) {
                $location.search(param, params[param]);
                $location.replace();
            }
            const position = $('body').scrollTop();
            broker.publish('REFRESHSEARCH', { newSearch: true });
            const listener = scope.$on(
                '$locationChangeSuccess',
                () => {
                    $('body').scrollTop(position);
                    listener();
                });
        }

        function _startSearch(params) {
            scope.$emit('block', {
                title: resourceService.get('SEARCHINGDEALS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-dealsSearchUnit'
            });
            for (let param in params) {
                $location.search(param, params[param]);
            }
            $location.path(`/holidaydeals`);
        }

        function _validateParameters(params) {
            if (_getNumberOfNonInfantPassengers(params.occupancy[0]) > 12) {
                scope.$emit('flash:error',
                    String.format(decodeURI(resourceService.get('TOOMANYPASSENGERS')),
                        `${TRPCONFIG.DesktopUrlRoot}/Help/Groupbookings.aspx`,
                        resourceService.get('TELEPHONENUMBER')));
                return false;
            }
            const childAges = _.get<any[]>(params, 'occupancy[0].ChildAges');
            const isValidOccupancy = _.every(childAges, ca => typeof ca !== 'undefined');
            if (!isValidOccupancy) {
                scope.$emit('flash:error', resourceService.get('CHILDAGESERROR'));
            } else {
                scope.$emit('flash:hide', resourceService.get('CHILDAGESERROR'));
            }
            return isValidOccupancy;
        }

        function _getNumberOfNonInfantPassengers(occ) {
            function _isolateNonInfants(value) {
                return value >= 2;
            }
            const childrenNumber = occ.ChildAges.filter(_isolateNonInfants).length;
            return occ.Adults + childrenNumber;
        }

        function _getNextMonth() {
            const today = new Date();
            let month = today.getMonth();
            const year = month === 11 ? today.getFullYear() + 1 : today.getFullYear();
            month = month === 11 ? 0 : month + 1;
            return new Date(year, month, 15, 0, 0, 0, 0);
        }
    }
}
